import {ActionButtonRow, EntityTable, HeadlineH1, LoadingIndicator} from 'arkulpa-fec';
import gql from 'graphql-tag';
import {FlatButton} from 'material-ui';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {Query, Mutation} from 'react-apollo';
import {withRouter} from 'react-router';
import styled from 'styled-components';

const boolOutput = (value) => (value ? 'true' : 'false');

const MakroOuput = styled.div`
  background: ${({isMakro}) => (isMakro ? 'green' : 'transparent')};
  color: ${({isMakro}) => (isMakro ? 'white' : 'black')};
  padding: 10px;
`;

const MikroOuput = styled.div`
  background: ${({isMikro}) => (isMikro ? 'yellow' : 'transparent')};
  color: black;
  padding: 10px;
`;

const _tableConfig = (maxRows) => {
  return {
    maxRows,
    cols: [
      {
        header: 'Timestamp',
        valueKey: 'timestampStr',
        method: (timestampStr) => moment(timestampStr).format('DD.MM.YYYY, h:mm:ss'),
        width: '15%',
      },
      {
        header: 'c',
        valueKey: 'c',
        method: (c) => c,

        width: '10%',
      },
      {
        header: 'r',
        valueKey: 'r',
        method: (r) => r,

        width: '10%',
      },
      {
        header: 'occupied',
        valueKey: 'occupied',
        method: (occupied) => boolOutput(occupied),

        width: '10%',
      },
      {
        header: 'makro',
        valueKey: 'makro',
        method: (makro) => <MakroOuput isMakro={makro}>{boolOutput(makro)}</MakroOuput>,
        width: '10%',
      },
      {
        header: 'mirko',
        valueKey: 'mikro',
        method: (mikro) => <MikroOuput isMikro={mikro}>{boolOutput(mikro)}</MikroOuput>,

        width: '10%',
      },
    ],
  };
};

const GET_ALL_MOVEMENTS = gql`
  query allMovements($input: AllMovementsInput!) {
    allMovements(input: $input) {
      results {
        timestampStr
        c
        r
        occupied
        mikro
        makro
        createdAtStr
      }
      totalPages
    }
  }
`;

const RESET_MOVEMENT = gql`
  mutation resetMovementsForDevice($input: ResetMovementsForDeviceInput) {
    resetMovementsForDevice(input: $input)
  }
`;
const getParamsFromFilter = (filter) => {
  if (filter === 'mikro') {
    return {onlyMakro: false, onlyMikro: true};
  }
  if (filter === 'makro') {
    return {onlyMakro: true, onlyMikro: false};
  }
  return {onlyMakro: false, onlyMikro: false};
};

const DeviceMovement = ({
  match: {
    params: {deviceId, page = 1},
  },
  history,
}) => {
  return (
    <Query query={GET_ALL_MOVEMENTS} variables={{input: {deviceId, page, ...getParamsFromFilter()}}}>
      {({loading, error, data: {allMovements}, refetch}) => {
        if (loading) return <LoadingIndicator />;
        if (error) return `Error! ${error.message}`;

        return (
          <div>
            <HeadlineH1>Movements {deviceId}</HeadlineH1>
            <div>
              <FlatButton
                onClick={() => {
                  refetch({input: {deviceId, page, ...getParamsFromFilter('makro')}});
                }}
                label='only makro'
              />
              <FlatButton
                onClick={() => {
                  refetch({input: {deviceId, page, ...getParamsFromFilter('mikro')}});
                }}
                label='only mikro'
              />
              <FlatButton
                onClick={() => {
                  refetch({input: {deviceId, page, ...getParamsFromFilter('all')}});
                }}
                label='all'
              />
            </div>
            <EntityTable
              tableConfig={_tableConfig(500)}
              data={loading ? [] : allMovements.results}
              msg={'No log informations available'}
              totalRows={allMovements.results.length}
            />

            <ActionButtonRow>
              <FlatButton onClick={() => history.push(`/device/${deviceId}`)} label='Back to detail' />

              <Mutation mutation={RESET_MOVEMENT}>
                {(resetMovementsForDevice, {data}) => {
                  return (
                    <FlatButton
                      primary
                      onClick={(event) => {
                        resetMovementsForDevice({variables: {input: {deviceId}}})
                          .then((result) => {
                            console.log(result);
                            alert('process to recalculate sheduled, this takes some time');
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                      }}
                      label='start Device recalculation'
                    />
                  );
                }}
              </Mutation>
            </ActionButtonRow>
          </div>
        );
      }}
    </Query>
  );
};
DeviceMovement.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(DeviceMovement);



// WEBPACK FOOTER //
// ./src/components/DeviceMovement.js